import { action } from 'mobx';
import { TConnection } from '../../../../../../../api/blueprints/connection.template.types';
import { FieldKey, configList } from './connection-knovio-form.config';
import { LayoutOption } from '../../../../../../../api/connections.dao';
import { BaseConnectionFormVM } from '../base-connection-form.viewmodel';

interface IKnovioTemplateOption<T> {
    label: string;
    value: T;
}

export const enum FlyoutTabOptions {
    Overview = 'enableOverview',
    QuestionsAndAnswers = 'enableQAndA',
    Speakers = 'enableSpeakers',
}

const DEFAULT_EXPIRATION_DATE_VALUE = 30;

export class ConnectionKnovioFormVM extends BaseConnectionFormVM {
    public static flyoutTabsOptions: IKnovioTemplateOption<FlyoutTabOptions>[] = [
        { label: 'Overview', value: FlyoutTabOptions.Overview },
        { label: 'Q&A', value: FlyoutTabOptions.QuestionsAndAnswers },
        { label: 'Speakers', value: FlyoutTabOptions.Speakers },
    ];

    public static layoutOptions: IKnovioTemplateOption<LayoutOption>[] = [
        { label: 'Video Only', value: LayoutOption.VideoOnly },
        { label: 'Video Left', value: LayoutOption.VideoLeft },
        { label: 'Video Right', value: LayoutOption.VideoRight },
        { label: 'Audio & Slides', value: LayoutOption.AudioAndSlides },
    ];

    constructor(
        connection: TConnection,
        readonly addConnection: (connection: TConnection) => void,
        readonly editConnection: (connection: TConnection) => void,
    ) {
        super(connection, configList, addConnection, editConnection);
    }

    public get flyoutTabs() {
        return {
            [FlyoutTabOptions.Overview]: this.formDataCtrl.getValue(FieldKey.ENABLE_OVERVIEW),
            [FlyoutTabOptions.QuestionsAndAnswers]: this.formDataCtrl.getValue(FieldKey.ENABLE_QANDA),
            [FlyoutTabOptions.Speakers]: this.formDataCtrl.getValue(FieldKey.ENABLE_SPEAKERS),
        };
    }

    @action.bound
    public updateFlyoutTabsOptions(option: FlyoutTabOptions): void {
        const value = this.formDataCtrl.getValue(option);
        this.formDataCtrl.setValue(option, !value);
    }

    @action
    public disableExpirationDate(): void {
        this.formDataCtrl.setValue(FieldKey.ENABLE_EXPIRATION_DATE, false);
        this.formDataCtrl.setValue(FieldKey.EXPIRATION_DAYS, null);
    }

    @action
    public enableExpirationDate(): void {
        this.formDataCtrl.setValue(FieldKey.ENABLE_EXPIRATION_DATE, true);
        this.formDataCtrl.setValue(FieldKey.EXPIRATION_DAYS, DEFAULT_EXPIRATION_DATE_VALUE);
    };

    @action
    public setExpirationDays(value: string): void {
        this.formDataCtrl.setValue(FieldKey.EXPIRATION_DAYS, Number.parseInt(value, 10));
    }

    protected composeConnectionValues(): TConnection {
        const values = super.composeConnectionValues();
        if (values[FieldKey.ENABLE_EXPIRATION_DATE] !== true) {
            return { ...values, [FieldKey.EXPIRATION_DAYS]: null };
        }
        return values;
    }
}
